module.exports = __webpack_public_path__ + "d7c639084f684d66a1bc66855d193ed8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/font-awesome/4.6.3/font-awesome/fonts/fontawesome-webfont.svg?v=4.6.3
 ** module id = 539
 ** module chunks = 0
 **/